module.exports = __webpack_public_path__ + "img/thumbnail_SaltwaterCrocodile_f_normal.15b705f2.png";